import { GET_CUSTOMER_PRICE_KIND_LIST_Register } from "../../../../constants/ActionTypes";
import { zeroPad } from "../../../../util/DaFrameword";


const InitialValue={
    CustomerKindList:[]
}

function CustomerPriceKindRegister(state=InitialValue,action){

    switch (action.type) {
        case GET_CUSTOMER_PRICE_KIND_LIST_Register:
            debugger
            return {
                ...state,
                CustomerKindList:action.payload 
            }
        default:
           return state
    }  

}

export default CustomerPriceKindRegister;